
import { Component, Prop, Vue } from 'vue-property-decorator'

import BacModal from '@/components/BacModal.vue'
import BacButton from '@/components/BacButton.vue'
import BacInput from '@/components/BacInput.vue'
import { User } from '../../../lib/models/User'
import UIkit from 'uikit'

@Component({
  components: {
    BacButton,
    BacInput,
    BacModal
  }
})
export default class OperatingAreaModal extends Vue {
  @Prop({ default: () => new User() }) user!: User

  async updateEditedUser () {
    await this.user.update()
    UIkit.notification({
      message: 'Teilnehmer geupdated!',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
  }
}
